import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material";

interface IOSSwitchProps extends SwitchProps {
  switchColor?: string;
}

const IOSSwitch = styled((props: IOSSwitchProps) => {
  const { switchColor, ...other } = props;
  return (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...other}
    />
  );
})<IOSSwitchProps>(({ theme, switchColor }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: "0 !important",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          switchColor ??
          (theme.palette.mode === "dark" ? "#2ECA45" : "#009FF9"),
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.3,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor:
      theme.palette.mode === "light" ? "rgba(120,120,128,0.16)" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default IOSSwitch;
